const PromotionHandler = ({ promotions_raw = "", product_promotions_raw = "" }) => ({
  init() {
    const promotions = promotions_raw.split("|");
    const productPromotions = product_promotions_raw.split("|");

    document.addEventListener("cart:updated", async event => {
      const cart = event.detail.cart;
      const subtotal = cart.items_subtotal_price;
      const lineItems = cart.items;
      const source = event.detail.source;
      const isCartPage = source === "main-cart";

      for (const promotion of promotions) {
        const parts = promotion.split(",");
        if (parts.length < 2) continue;

        const threshold = Number(parts[0]);
        const variantId = Number(parts[1]);

        const match = lineItems.find(item => item.variant_id === Number(variantId));
        const subtotalWithoutMatch = subtotal - (match?.line_price ?? 0);

        // Item is in cart but threshold is not met, remove item
        if (!!match && subtotalWithoutMatch < threshold) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: {
                [match.id]: 0
              }
            })
          });

          window.setTimeout(
            () => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })),
            600
          );
          continue;
        }

        // Item is in cart already, continue
        if (!!match && subtotalWithoutMatch >= threshold) continue;

        // Item is not in cart but threshold is not met, continue
        if (!match && subtotal < threshold) continue;

        // Item is not in cart, add it!
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        window.setTimeout(
          () => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })),
          600
        );
        break;
      }

      for (const promotion of productPromotions) {
        const parts = promotion.split(",");
        if (parts.length < 2) continue;

        const productId = Number(parts[0]);
        const addonVariantId = Number(parts[1]);

        const match = lineItems.find(item => item.product_id === productId);
        const addonInCart = lineItems.find(item => item.variant_id === addonVariantId) !== undefined;

        if (!match || addonInCart) continue;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: addonVariantId, quantity: 1 }]
          })
        });

        window.setTimeout(
          () => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })),
          600
        );
      }

      if (isCartPage) window.setTimeout(() => window.location.reload(), 500);
    });
  }
});

export default PromotionHandler;
